import { render } from "./FormRegisterSection2.vue?vue&type=template&id=7493e8d4&scoped=true"
import script from "./FormRegisterSection2.vue?vue&type=script&lang=js"
export * from "./FormRegisterSection2.vue?vue&type=script&lang=js"

import "./FormRegisterSection2.vue?vue&type=style&index=0&id=7493e8d4&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7493e8d4"]])

export default __exports__